import Decimal from 'decimal.js';

export function sortAlpha(a: string, b: string): 0 | 1 | -1 {
  if (a > b) {
    return 1;
  } else if (b > a) {
    return -1;
  }

  return 0;
}

export function sortDecimal(a: Decimal, b: Decimal): 0 | 1 | -1 {
  if (a.greaterThan(b)) {
    return 1;
  } else if (b.greaterThan(a)) {
    return -1;
  }

  return 0;
}
